
import { atom } from 'jotai';

const filterSidepanelStatusAtom = atom({});
const filterSidepanelAtom = atom(false);

export { filterSidepanelAtom, filterSidepanelStatusAtom };